module.exports = __webpack_public_path__ + "static/media/Geomanist-Medium.55687bb8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Geomanist/Web/Geomanist-Medium.woff2
// module id = 6545
// module chunks = 1